"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shared = require("@clayui/shared");
var _react = _interopRequireDefault(require("react"));
var _Content = _interopRequireDefault(require("./Content"));
var _Item = _interopRequireDefault(require("./Item"));
var _List = require("./List");
var _TabPane = _interopRequireDefault(require("./TabPane"));
var _excluded = ["activation", "active", "children", "className", "defaultActive", "displayType", "fade", "justified", "modern", "onActiveChange"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
function Tabs(_ref) {
  var _left$type;
  var _ref$activation = _ref.activation,
    activation = _ref$activation === void 0 ? 'manual' : _ref$activation,
    externalActive = _ref.active,
    children = _ref.children,
    className = _ref.className,
    _ref$defaultActive = _ref.defaultActive,
    defaultActive = _ref$defaultActive === void 0 ? 0 : _ref$defaultActive,
    displayType = _ref.displayType,
    _ref$fade = _ref.fade,
    fade = _ref$fade === void 0 ? false : _ref$fade,
    justified = _ref.justified,
    _ref$modern = _ref.modern,
    modern = _ref$modern === void 0 ? false : _ref$modern,
    onActiveChange = _ref.onActiveChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useControlledState = (0, _shared.useControlledState)({
      defaultName: 'defaultActive',
      defaultValue: defaultActive,
      handleName: 'onActiveChange',
      name: 'active',
      onChange: onActiveChange,
      value: externalActive
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 3),
    active = _useControlledState2[0],
    setActive = _useControlledState2[1],
    isUncontrolled = _useControlledState2[2];
  var _React$Children$toArr = _react.default.Children.toArray(children),
    _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 2),
    left = _React$Children$toArr2[0],
    right = _React$Children$toArr2[1];
  var tabsId = (0, _shared.useId)();

  // @ts-ignore
  if ((left === null || left === void 0 ? void 0 : (_left$type = left.type) === null || _left$type === void 0 ? void 0 : _left$type.displayName) === 'ClayTabsList') {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(left, {
      activation: activation,
      active: active,
      displayType: displayType,
      justified: justified,
      modern: modern,
      onActiveChange: setActive,
      shouldUseActive: isUncontrolled,
      tabsId: tabsId
    }), /*#__PURE__*/_react.default.isValidElement(right) && /*#__PURE__*/_react.default.cloneElement(right, {
      active: active,
      fade: fade,
      tabsId: tabsId
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_List.List, _extends({}, otherProps, {
    activation: activation,
    active: active,
    className: className,
    displayType: displayType,
    justified: justified,
    modern: modern,
    onActiveChange: setActive
  }), children);
}

/**
 * @deprecated since v3.78.2 - Use new composition with Tabs.List and Tabs.Panels.
 */
Tabs.Content = _Content.default;
Tabs.Panels = _Content.default;
Tabs.Item = _Item.default;
Tabs.List = _List.List;
Tabs.TabPane = _TabPane.default;
Tabs.TabPanel = _TabPane.default;
var _default = exports.default = Tabs;